import React, { useState } from 'react';
import axios from 'axios';
import { Loader2, Search, Globe } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const TagInputSection = ({ inputText, setInputText, handleGenerate, loading, advancedSeo, setAdvancedSeo, language, setLanguage, examples }) => {
  const languages = [
    "English", "Spanish", "French", "German", "Portuguese",
    "Russian", "Japanese", "Korean", "Arabic", "Hindi",
    "Italian", "Dutch", "Turkish", "Polish", "Indonesian"
  ];

  return (
    <div className="space-y-8 md:space-y-12">
      <div className="relative max-w-3xl mx-auto">
        <div className="relative flex flex-col sm:flex-row items-stretch sm:items-center bg-card border border-border rounded-2xl sm:rounded-full shadow-lg focus-within:ring-2 focus-within:ring-accent transition-all p-2 gap-2 sm:gap-0">
          <div className="hidden sm:block pl-4 text-muted-foreground">
              <Search size={20} />
          </div>
          <input
            type="text"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleGenerate()}
            placeholder="Enter video title or keyword..."
            className="flex-1 bg-transparent border-none py-4 px-4 text-base sm:text-lg font-medium focus:ring-0 focus:outline-none placeholder:text-muted-foreground/50 w-full min-h-[48px]"
            data-testid="input-text"
          />
          <button
              onClick={() => handleGenerate()}
              disabled={loading}
              className="bg-primary text-primary-foreground hover:opacity-90 px-8 py-3.5 rounded-full text-base font-bold transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center w-full sm:w-auto sm:min-w-[140px] min-h-[48px]"
              data-testid="generate-btn"
          >
              {loading ? <Loader2 className="animate-spin" size={20} /> : "Generate"}
          </button>
        </div>
        
        <div className="flex flex-col sm:flex-row sm:flex-wrap sm:justify-between sm:items-center mt-4 px-2 gap-3 sm:gap-4 relative z-10">
            <div className="flex items-center gap-2 bg-card border border-border px-4 py-3 rounded-full hover:border-accent transition-colors min-h-[48px]">
              <Globe size={16} className="text-muted-foreground" />
              <select
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                className="bg-transparent text-sm font-medium focus:outline-none cursor-pointer text-foreground appearance-none pr-4 outline-none flex-1"
                data-testid="language-select"
              >
                {languages.map(l => <option key={l} value={l} className="bg-background text-foreground">{l}</option>)}
              </select>
            </div>

            <label className="flex items-center justify-between sm:justify-start gap-3 cursor-pointer group select-none relative z-10 bg-card sm:bg-transparent border border-border sm:border-0 px-4 py-3 sm:p-0 rounded-full min-h-[48px]">
              <span className="text-sm font-medium text-muted-foreground group-hover:text-foreground transition-colors">
              Advanced SEO Mode
              </span>
              <div className="relative">
                  <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={advancedSeo}
                      onChange={(e) => setAdvancedSeo(e.target.checked)}
                      data-testid="advanced-seo-toggle"
                  />
                  <div className="w-11 h-6 bg-muted peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-background after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent pointer-events-none"></div>
              </div>
          </label>
        </div>
      </div>

      <div className="text-center space-y-4">
          <p className="text-sm text-muted-foreground px-4">Try these examples to get started</p>
          <div className="flex flex-wrap justify-center gap-2 md:gap-3 px-4">
              {examples.map((ex) => (
                  <button 
                      key={ex}
                      onClick={() => handleGenerate(ex)}
                      className="px-4 py-2.5 rounded-full border border-border bg-card hover:bg-accent hover:text-accent-foreground text-sm font-medium transition-colors min-h-[44px]"
                  >
                      {ex}
                  </button>
              ))}
          </div>
      </div>
    </div>
  );
};

export default TagInputSection;
